export default "data:video/mp2t;base64,ZXhwb3J0IGNvbnN0IEZPUk1fVVJMX0tFWSA9ICdla3ljJzsK"